import { NgModule } from '@angular/core';
import { ThemeModule } from '../../@theme/theme.module';
import { DeviceRoutingModule, routedComponents } from './device-routing.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NbActionsModule, NbCardModule, NbIconModule, NbInputModule, NbSpinnerModule, NbToggleModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    DeviceRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
  ],
  declarations: [
    ...routedComponents,
  ],
})
export class DeviceModule { }
